<template>
  <div
    ref="selectDeptWrap"
    class="block-main"
    @click.stop="handleFocusInput"
    :class="{ active: isFocus }"
  >
    <el-popover
      placement="bottom-start"
      transition="el-zoom-in-top"
      v-model="isShowPopover"
      :width="popoverWidth"
      trigger="manual"
      :arrow-offset="25"
      popper-class="el-popover-small-padding"
    >
      <div class="template-wrap">
        <div class="left-side">
          <template v-for="(item, index) in templateList">
            <el-button
              class="temp-item"
              :key="index"
              :type="activeTempId === item.id ? 'primary' : 'info'"
              plain
              @click="handleFirstempSelect(item)"
            >
              {{ item.name }}
            </el-button>
          </template>
        </div>
        <div class="right-side" v-if="rightSideTemplateList.length > 0">
          <el-alert
            title="切换分组，将清空已选规格及信息"
            type="warning"
            :closable="false"
            show-icon
            class="warning-tip"
          />
          <template v-for="(item, index) in rightSideTemplateList">
            <el-button
              class="temp-item"
              :key="index"
              :type="activeValueId == item.id ? 'primary' : 'info'"
              plain
              @click="handleSelectTemplate(item)"
            >
              {{ item.name }}
            </el-button>
          </template>
        </div>
      </div>
      <div slot="reference">
        <div class="select-info">
          <el-input
            ref="inputVal"
            placeholder="请选择"
            v-model="queryTxt"
            class="search-input"
            @input="searchTemplate"
            :style="{ width: searchInputWidth }"
            :readonly="readonly"
          ></el-input>
        </div>
        <!-- @focus.stop="showPopover" -->
      </div>
    </el-popover>
  </div>
</template>

<script>

import { cloneDeep } from 'lodash';
export default {
  name: 'SelectDept',
  components: {
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    searchInputWidth: {
      type: String,
      default: '300px'
    },
    firstTempId: {
      type: [String, Number],
      default: ''
    },
    valueId: {
      type: [String, Number],
      default: ''
    },
    templateList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    readonly: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      isShowPopover: false,
      isFocus: false,
      queryTxt: '',
      isMounted: false,
      popoverWidth: '400px',
      activeTempId: '',
      activeValueId: '',
    };
  },
  watch: {
    firstTempId: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.activeTempId = newVal;
      }
    },
    valueId: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.activeValueId = newVal;
      }
    },
    value: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.queryTxt = newVal;
      }
    }
  },
  computed: {
    rightSideTemplateList() {
      const matchItem = this.templateList.find(item => {
        return item.id === this.activeTempId;
      });
      if (matchItem) {
        return matchItem.children || [];
      }
      return [];
    },
  },
  mounted() {
    this.isMounted = true;
  },
  destroyed() {
    this.isMounted = false;
  },
  methods: {
    showPopover() {
      // console.log('focus', 'focus');
      // this.popoverWidth = this.$refs.selectDeptWrap.clientWidth;
      this.isShowPopover = true;
      // 多层模板默认选择第一个
      if (this.templateList.length > 0 && this.templateList[0].children && !this.activeTempId) {
        this.activeTempId = this.templateList[0].id;
      }
      window.addEventListener('click', this.eventListener);
    },
    eventListener(e) {
      // console.log('eventListener', e)
      this.operatePopover();
    },
    hidePopover() {
      this.isShowPopover = false;
      window.removeEventListener('click', this.eventListener);
    },
    operatePopover() {
      if (this.isFocus) {
        this.handleFocusInput();
      }
    },
    handleFocusInput(e) {
      console.log('handleFocusInput',e);
      this.isFocus = !this.isFocus;
      if (this.isFocus) {
        this.showPopover();
        this.$refs.inputVal.focus();
      } else {
        this.hidePopover();
        this.$refs.inputVal.blur();
      }
    },
    handleRemoveItem(key) {
    },
    emitInputForm() {
      if (this.$parent.$options.componentName === 'ElFormItem') {
        this.$parent.$emit('el.form.change', this.value);
        this.$parent.$emit('el.form.blur', this.value);
      }
    },
    handleFirstempSelect(item) {
      const { name, id, children } = item;
      if (!children) {
        this.$emit('change', {
          name, id
        });
        this.activeTempId = id;
        this.operatePopover();
      } else {
        this.activeTempId = id;
      }
    },
    handleSelectTemplate(item) {
      const { name, id } = item;
      this.$emit('change', {
        name, id,
        firstTempId: this.activeTempId,
      });
      this.operatePopover();
    },
    searchTemplate(val) {
      this.$emit('change', {
        name: val,
        id: null,
        firstTempId: null,
      });
      this.isFocus = false;
      this.hidePopover();
    },
    handleClear() {
      this.$refs.tree.setCheckedKeys([]);
    },
  }
};
</script>

<style lang="scss" scoped>
.block-main {
  outline: 1px solid #dcdfe6;
  border-radius: 2px;
  box-sizing: border-box;
  font-size: 0;
  line-height: 0;
  padding: 0;
  width: 300px;
  &.active {
  }
  .select-info {
    display: inline-block;
    box-sizing: border-box;
    padding-left: 0px;
    padding: 0;
    // width: 180px;
    ::v-deep .el-tag {
      max-width: 120px;
      position: relative;
      padding: 0 20px 0 8px;
      // margin-left: 4px;
      margin: 0 3px 0 3px;
      vertical-align: middle;
      .el-tag__close {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 2px;
      }
    }
    .search-input {
      vertical-align: middle;
      height: 28px;
      line-height: 28px;
    }
  }
  .search-input {
    ::v-deep .el-input__inner {
      border: none;
      padding: 0 11px;
    }
  }
}
.template-wrap{
  min-height: 60px;
  display: flex;
  width: 400px;
  .left-side{
    width: 85px;
    flex-shrink: 0;
    flex-grow: 1;
    .temp-item{
      text-align: center;
      height: 24px;
      line-height: 24px;
      margin-bottom: 4px;
      cursor: pointer;
      min-width: 80px;
      padding: 0;
    }
    ::v-deep .el-button+.el-button{
      margin-left: 0;
    }
  }
  .right-side{
    flex-grow: 1;
    box-sizing: border-box;
    padding: 0 4px;
    border-left: 1px solid #dcdfe6;
    flex-shrink: 0;
    width: calc(100% - 85px);
    .temp-item{
      margin-bottom: 4px;
      &:not(:last-of-type) {
        margin-right: 4px;
      }
    }
    ::v-deep .el-button+.el-button{
      margin-left: 0;
    }
    .warning-tip{
      padding: 2px 4px;
      margin-bottom: 8px;
      ::v-deep .el-alert__content{
        padding: 0 4px;
      }
      ::v-deep .el-alert__title{
        font-size: 12px;
      }
    }
  }
}
</style>
